import { Button, Grid, Theme, makeStyles } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import FormatListBulletedSharpIcon from "@material-ui/icons/FormatListBulletedSharp";
import { ColDef, ICellRendererParams } from "ag-grid-community";
import React from "react";
import {
	RecipientTypeChips,
	getRecipientText,
} from "../../../emailTopics/components/RecipientTypeChips";
import { EmailAddress } from "../../../emailTopics/models/EmailAddress";
import { useEmailAddressesContext } from "../../context/EmailAddressesContext";

const useStyles = makeStyles((theme: Theme) => ({
	root: {},
}));

const getTopicsByType = (address?: EmailAddress) => ({
	TO: address?.TopicsTO,
	CC: address?.TopicsCC,
	BCC: address?.TopicsBCC,
});

type Props = {
	setOpenModalEditAddress: Function;
	setOpenModalDeleteAddress: Function;
	showContextMenu: Function;
};

export const useTableData = ({
	setOpenModalEditAddress,
	setOpenModalDeleteAddress,
	showContextMenu,
}: Props) => {
	const { actions } = useEmailAddressesContext();
	const classes = useStyles();

	const columnDefs: ColDef[] = [
		{
			field: "Address",
			headerName: "Address",
			flex: 1.5,
			minWidth: 180,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
			},
		},
		{
			field: "Topics",
			headerName: "Topics",
			flex: 3,
			minWidth: 200,
			wrapText: true,
			autoHeight: true,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "flex-start",
			},
			valueGetter: ({ data }) => getRecipientText(getTopicsByType(data), 15),
			cellRenderer: ({ data }: ICellRendererParams) => (
				<RecipientTypeChips values={getTopicsByType(data)} maxVisible={15} />
			),
		},
		{
			headerName: "",
			field: "-",
			sortable: false,
			filter: false,
			flex: 1,
			minWidth: 160,
			cellStyle: {
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
			},
			cellRenderer: (params: ICellRendererParams) => (
				<Grid
					container
					style={{
						height: "100%",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
					className={classes.root}
				>
					<Grid
						item
						xs={12}
						md={12}
						style={{
							display: "flex",
							justifyContent: "center",
							alignItems: "center",
						}}
					>
						<Button
							size="small"
							style={{ minWidth: 36, padding: 4 }}
							onClick={() => {
								actions.setAddressSelected(params?.data as EmailAddress);
								setOpenModalEditAddress(true);
							}}
						>
							<EditIcon color="primary" fontSize="small" />
						</Button>
						<Button
							size="small"
							style={{ minWidth: 36, padding: 4 }}
							onClick={() => {
								actions.setAddressSelected(params?.data as EmailAddress);
								setOpenModalDeleteAddress(true);
							}}
						>
							<DeleteIcon color="secondary" fontSize="small" />
						</Button>
						<Button
							size="small"
							style={{ minWidth: 36, padding: 4 }}
							onClick={(e) =>
								showContextMenu(e, params.data, "TableEmailAddresses")
							}
						>
							<FormatListBulletedSharpIcon color="action" fontSize="small" />
						</Button>
					</Grid>
				</Grid>
			),
		},
	];

	return { columnDefs };
};
